<div
    mdbModal
    #cartCustomizationModal="mdbModal"
    id="add-to-cart-confirmation-modal"
    class="modal fade overflow-y-auto"
    tabindex="-1"
    role="dialog"
    (closed)="hideDialog()"
>
    <div class="modal-dialog modal-lg modal-dialog-centered scrollable-modal" role="document">
        <div class="modal-content" id="add-to-cart-confirmation-container">
            <div class="modal-content add-to-cart-confirmation-content">
                <div class="modal-header" id="add-to-cart-confirmation-header">
                    <div class="pull-left">
                        <h3 id="add-to-cart-confirmation-header-title" data-testid="add-to-cart-confirmation-header-title">
                            <i class="fa fa-check-circle text-success"></i> Item added to your cart
                        </h3>
                    </div>
                    <button
                        type="button"
                        class="close pull-right close-align modal-close-button"
                        data-testid="add-to-cart-modal-close-button"
                        aria-label="Close"
                        (click)="hideDialog()"
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="add-to-cart-confirmation-body">
                    <div class="container-fluid">
                        <ng-container *ngIf="addToCartConfirmationDto">
                            <div class="row new-border-top new-border-bottom mt-3 pt-3" id="add-to-cart-item-details-row">
                                <ng-container *ngIf="addToCartConfirmationDto.ImageDataburst != null">
                                    <p id="add-to-cart-confirmation-image" class="col-md-3 col-sm-12 col-xs-12">
                                        <img
                                            style="min-height: 100px"
                                            src="{{ addToCartConfirmationDto.ImageHtml.Src }}"
                                            srcset="{{ addToCartConfirmationDto.ImageHtml.SrcSet }}"
                                            sizes="{{ addToCartConfirmationDto.ImageHtml.Sizes }}"
                                            class="img-responsive"
                                        />
                                    </p>
                                </ng-container>
                                <div class="col-md-9 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div>
                                                <h3 id="add-to-cart-confirmation-item-name">
                                                    {{ addToCartConfirmationDto.Manufacturer }}
                                                    {{ addToCartConfirmationDto.Description }}
                                                </h3>
                                                <h6 id="add-to-cart-confirmation-item-price">
                                                    {{ addToCartConfirmationDto.SellingPriceFormatted }}
                                                </h6>
                                                <br />
                                                <ng-container *ngIf="addToCartConfirmationDto.FreeItems?.length">
                                                    <strong>Includes free: </strong>

                                                    <ng-container
                                                        *ngFor="let freeItem of addToCartConfirmationDto.FreeItems"
                                                    >
                                                        <br />
                                                        {{ freeItem.Manufacturer }} {{ freeItem.Description }}
                                                        <strong>({{ freeItem.SellingPriceFormatted }} value)</strong>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </div>

                                        <div class="col-md-12 text-right">
                                            <a class="btn btn-default bmd-ripple-only mdkit-button" href="/cart"
                                               data-testid="add-to-cart-modal-view-cart-button"
                                                >View Cart</a
                                            >
                                            <a
                                                class="btn mdkit-button btn-raised btn-primary bmd-ripple"
                                                href="/cart/checkout"
                                                data-testid="add-to-cart-modal-view-checkout-button"
                                            >
                                                <i class="fa fa-shopping-cart icon-on-left"></i> Checkout
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="addToCartConfirmationDto.ServicePlans?.length">
                                <app-service-plans-row
                                    [parentItemWebCode]="addToCartConfirmationDto.Webcode"
                                    [servicePlans]="addToCartConfirmationDto.ServicePlans"
                                    [isOnCartPage]="false"
                                ></app-service-plans-row>
                            </ng-container>

                            <ng-container *ngIf="frequentlyBoughtTogether?.length">
                                <app-frequently-bought-together
                                    [recommendations]="frequentlyBoughtTogether"
                                    [isDialogMode]="true"
                                    [source]="'Frequently Bought Together - Add To Cart Confirmation Dialog'"
                                ></app-frequently-bought-together>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
